import type { Film } from "@/mocks/films";
import FilmCard from "./FilmCard";

interface FilmGridProps {
  films: Film[];
  favorites?: string[];
  onToggleFavorite?: (id: string) => void;
  columns?: 3 | 4;
}

export default function FilmGrid({
  films,
  favorites = [],
  onToggleFavorite,
  columns = 4,
}: FilmGridProps) {
  const gridClass =
    columns === 3
      ? "grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3"
      : "grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4";

  return (
    <div className={gridClass}>
      {films.map((film) => (
        <FilmCard
          key={film.id}
          film={film}
          favorited={favorites.includes(film.id)}
          onToggleFavorite={onToggleFavorite}
        />
      ))}
    </div>
  );
}